import React, { Component } from 'react';
import IconList             from './App/IconList';
import IconMap              from './App/IconMap';
import IconCenter           from './App/IconCenter';
import IconInfo             from './App/IconInfo';
import ReactTooltip         from 'react-tooltip';
import ImageModal           from './../components/ImageModal';
import _                    from 'lodash';
import './../css/ToggleView.css';
import './../css/modal-video.min.css';

class SwitchView extends Component
{

    state = {
        videoOpen: false
    };

    //---------------------------------------------------------------------------------------------------------------

    toggleView = () =>
    {
        this.props.toggleView();
    };

    //---------------------------------------------------------------------------------------------------------------

    centerToUser = () =>
    {
        let bounds = new window.google.maps.LatLngBounds();
        let latLng = new window.google.maps.LatLng(this.props.geo.coords.latitude, this.props.geo.coords.longitude);
        bounds.extend(latLng);

        /**
         * The zoom level is too when we pan to a single point and set zoom is not exposed on the
         * react component so add 2 extension points to the bounds.
         */
        let extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
        let extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);

        this.props.map.mapObject.fitBounds(bounds);
        this.props.map.mapObject.panToBounds(bounds);
    };

    //---------------------------------------------------------------------------------------------------------------

    renderButton = () =>
    {
        if (this.props.isList(this.props.viewType))
        {
            return (
                <div data-tip="Switch to map view" onTouchTap={ this.toggleView }>
                    <IconMap />
                </div>
            );
        }
        else
        {
            return (
                <div data-tip="Switch to list view" onTouchTap={ this.toggleView }>
                    <IconList />
                </div>
                );
        }
    };

    //---------------------------------------------------------------------------------------------------------------

    renderIconCenter = () => {
        let className    = 'icon';
        let centerToUser = this.centerToUser;

        if (null === this.props.geo.coords || null === this.props.map.mapObject)
        {
            className = 'icon disabled';
            centerToUser = _.noop;
        }

        return (
            <div data-tip="Centre the map to your location" onTouchTap={ centerToUser }>
                <IconCenter className={ className }  />
            </div>
        );
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () =>
    {
        if (true === this.props.show)
        {
            return (
                <div>
                    { this.renderButton() }
                    { this.renderIconCenter() }
                    <div data-tip="Places and Trails explainer" onTouchTap={ () => { this.setState({ videoOpen: true }) } }>
                        <IconInfo/>
                    </div>
                    <ImageModal
                        show={ this.state.videoOpen }
                        onClose={() => this.setState({ videoOpen: false }) }
                        image="https://s3-eu-west-1.amazonaws.com/placesandtrails/master/assets/explainer.jpg"
                    />
                    <ReactTooltip globalEventOff="click" type="light" place="left" />
                </div>
            );
        }

        return null;
    };

}

export default SwitchView;



// WEBPACK FOOTER //
// ./src/components/SwitchView.js